import React, { ChangeEventHandler, ReactNode } from 'react';
import classNames from 'classnames';
import * as uuid from 'uuid';
import { IconCheckbox } from '../../assets/icons';
import { ErrorFormMessage } from '../error-form-message/error-form-message';
import './index.scss';

type CheckboxProps = {
  children?: ReactNode;
  checked?: boolean;
  id?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  isFullWidth?: boolean;
  disabled?: boolean;
  isUnavailable?: boolean;
  reverse?: boolean;
  labelBold?: boolean;
  className?: string;
  errorMessage?: string | null;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  children,
  id = uuid.v4(),
  checked = false,
  onChange,
  isFullWidth = false,
  disabled = false,
  isUnavailable = false,
  reverse = false,
  labelBold = false,
  className,
  errorMessage = '',
}) => (
  <div
    className={classNames('checkbox', className, {
      'checkbox--full-width': isFullWidth,
      'checkbox--unavailable': isUnavailable,
      'checkbox--width-auto': !children,
      reverse: reverse,
    })}
  >
    <div className="checkbox__container">
      <input type="checkbox" id={id} checked={checked} disabled={disabled} value={id} onChange={onChange} />
      <label htmlFor={id}>
        {children && <div className={classNames('checkbox__label', { bold: labelBold })}>{children}</div>}
        <div className="checkbox__icon">
          <IconCheckbox isChecked={checked} isDisabled={disabled} />
        </div>
      </label>
    </div>
    {errorMessage && <ErrorFormMessage errorMessage={errorMessage} />}
  </div>
);
